// src/i18n.js
// ─────────────────────────────────────────────────────────────────────────────
// react-i18next kurulumu.
// Desteklenen: 'tr' (Türkçe), 'en' (İngilizce)
// Varsayılan: 'en' — Firebase'den kullanıcı tercihi gelirse override edilir.
//
// CRA NOTU: import.meta.env ÇALIŞMAZ — process.env.NODE_ENV kullanılır.
// Kurulum: npm install i18next react-i18next
// ─────────────────────────────────────────────────────────────────────────────
import i18n                 from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector    from "i18next-browser-languagedetector";

const resources = {

  // ── TÜRKÇE ────────────────────────────────────────────────────────────────
  tr: {
    translation: {
      common: {
        loading: "Yükleniyor...", save: "Kaydet", cancel: "İptal",
        delete: "Sil", back: "Geri Dön", edit: "Düzenle", confirm: "Onayla",
        checking: "Kontrol ediliyor...", sending: "Gönderiliyor...",
        deleting: "Siliniyor...", sealing: "Mühürleniyor...", or: "veya",
      },
      comments: {
        title: "Yorumlar", show: "Yorumları göster", hide: "Yorumları gizle",
        count: "{{count}} yorum", empty: "Henüz yorum yok.",
        label: "Yorum ekle", placeholder: "Yorumunu yaz...", post: "Gönder",
        posting: "Gönderiliyor...", delete: "Sil", you: "Sen", member: "Kullanıcı",
        loginRequired: "Yorum yapmak için giriş yap.", invalid: "Yorum 1-1000 karakter arasında olmalı.",
        loadError: "Yorumlar yüklenemedi.", saveError: "Yorum gönderilemedi.", deleteError: "Yorum silinemedi.",
      },
      auth: {
        login: "Giriş Yap", register: "Kayıt Ol", logout: "Çıkış Yap",
        email: "E-posta", password: "Şifre", passwordRepeat: "Şifreyi Tekrar Gir",
        displayName: "İsim Soyisim", forgotPassword: "Şifremi unuttum",
        resetPassword: "Şifreyi Sıfırla", resetSend: "Sıfırlama E-postası Gönder",
        verifyEmail: "E-posta doğrulaması gönderildi.",
        welcomeBack: "Hoş Geldin", createAccount: "Hesap Oluştur",
        alreadyHave: "Zaten hesabın var mı?", noAccount: "Hesabın yok mu?",
        backToLogin: "← Giriş ekranına dön",
        backToHome: "← Ana Sayfa",
        archiveEyebrow: "✦ BoneCast Arşivleri ✦",
        loginWith: "Giriş Yap", registerWith: "Kayıt Ol",
        googlePrefix: "🔍 Google ile",
        googleHint: "İlk kez Google ile giriş yapıyorsan hesabın otomatik oluşturulur.",
        termsAgree: "'nı okudum ve kabul ediyorum.",
        termsLink: "Kullanım Koşulları", privacyLink: "Gizlilik Politikası", termsAnd: "ve",
        passwordMatch: "✓ Şifreler eşleşiyor", passwordNoMatch: "✗ Şifreler eşleşmiyor",
        errors: {
          termsRequired:      "Lütfen devam etmek için koşulları onaylayın.",
          nameRequired:       "İsim zorunludur.",
          emailRequired:      "E-posta zorunludur.",
          passwordRequired:   "Şifre zorunludur.",
          passwordTooShort:   "Şifre en az 6 karakter olmalı.",
          passwordMismatch:   "Şifreler eşleşmiyor.",
          emailAndPwRequired: "E-posta ve şifre zorunludur.",
          emailRequired2:     "E-posta adresini gir.",
          nameTaken:          "Bu isim zaten bir başka sakin tarafından alınmış.",
          generic:            "Bir sorun oluştu, lütfen tekrar deneyin.",
          timeout:            "İşlem zaman aşımına uğradı. Lütfen tekrar dene.",
          userNotFound:       "E-posta adresi veya şifre yanlış.",
          wrongPassword:      "E-posta adresi veya şifre yanlış.",
          invalidCredential:  "E-posta adresi veya şifre yanlış.",
          emailInUse:         "Bu e-posta adresi zaten kullanımda.",
          invalidEmail:       "Geçersiz e-posta adresi.",
          weakPassword:       "Şifre en az 6 karakter olmalı.",
          tooManyRequests:    "Çok fazla deneme. Lütfen birkaç dakika bekle.",
          networkFailed:      "Bağlantı hatası. İnternet bağlantını kontrol et.",
          popupClosed:        "Google girişi iptal edildi.",
          emailNotVerified:   "E-posta adresiniz henüz doğrulanmamış. Lütfen mail kutunuzu kontrol edin.",
          requiresRecentLogin:"Güvenlik nedeniyle tekrar giriş yapıp bu işlemi deneyin.",
          dbWriteFailed:      "Veritabanına kaydedilemedi. Firebase kurallarını kontrol et.",
          invalidEmailDomain: "Bu e-posta servisi desteklenmiyor. Gmail, Outlook, Yahoo gibi yaygın bir servis kullan.",
          emailRequired3:     "Lütfen e-posta adresini gir.",
          termsShort:         "Lütfen koşulları onaylayın.",
          resetSent:          "Şifre sıfırlama e-postası gönderildi. Gelen kutunu kontrol et.",
        },
        googleProfile: {
          eyebrow:     "Profil Oluştur",
          desc:        "Google hesabınla giriş yaptın. Topluluğa katılmadan önce kendine benzersiz bir kullanıcı adı seç.",
          nameLabel:   "Kullanıcı Adı",
          namePlaceholder: "Seni temsil eden bir isim...",
          checking:    "Kontrol ediliyor...",
          available:   "Bu isim kullanılabilir!",
          btn:         "Devam Et",
          hint:        "Bu isim profilinde ve topluluğa katkılarında görünecek.",
          verified:    "Doğrulandı",
        },
        link: {
          eyebrow:           "Hesap Birleştirme",
          desc:              "Bu e-posta adresiyle zaten bir hesabın var. Google girişini mevcut hesabına bağlamak için şifreni gir.",
          passwordLabel:     "Mevcut Hesap Şifresi",
          passwordPlaceholder: "Şifreni gir...",
          btn:               "Google'ı Hesabıma Bağla",
        },
      },
      settings: {
        title: "Hesap Ayarları", eyebrow: "✦ Profil ✦",
        section: {
          profile: "Profil", accountInfo: "Hesap Bilgileri",
          updateName: "Kullanıcı Adını Güncelle", changePassword: "Şifre Değiştir",
          dangerZone: "Tehlikeli Alan",
        },
        avatar: {
          change: "Fotoğraf Değiştir", modalEyebrow: "✦ Seç ✦",
          modalTitle: "Profil Fotoğrafı",
          updated: "Profil fotoğrafı güncellendi.", failed: "Fotoğraf kaydedilemedi.",
        },
        bio: {
          label: "Hakkımda (maks. 200 karakter)",
          placeholder: "Kendini kısaca tanıt...",
          tooLong: "Hakkımda alanı en fazla 200 karakter olabilir.",
        },
        nationality: { label: "Uyruk", placeholder: "— Seçiniz —" },
        language:    { label: "Dil Tercihi" },
        seal: {
          button: "⚜ Ayarları Mühürle", loading: "Mühürleniyor...",
          success: "Ayarlar mühürlendi. Profil güncellendi.",
          error: "Güncelleme başarısız. Lütfen tekrar dene.",
        },
        email: { label: "E-posta Adresi (değiştirilemez)" },
        name: {
          label: "Yeni Kullanıcı Adı", placeholder: "İsim Soyisim",
          save: "Kaydet", checking: "Kontrol ediliyor...",
          success: "Kullanıcı adı başarıyla güncellendi.",
          toastSuccess: "Kullanıcı adı güncellendi.",
          empty: "İsim boş olamaz.",
          same: "Yeni isim mevcut isimden farklı olmalı.",
          taken: "Bu isim zaten bir başka sakin tarafından alınmış.",
          error: "Güncelleme başarısız. Lütfen tekrar dene.",
        },
        password: {
          info: "Güvenlik amacıyla şifreni buradan doğrudan değiştiremezsin. Aşağıdaki butona tıklayarak",
          infoSuffix: "adresine bir şifre sıfırlama bağlantısı gönderilir.",
          send: "Sıfırlama E-postası Gönder", sending: "Gönderiliyor...",
          success: "adresine sıfırlama bağlantısı gönderildi.",
          error: "E-posta gönderilemedi. Lütfen tekrar dene.",
        },
        deleteAccount: {
          title: "Hesabı Kalıcı Olarak Sil",
          info: "Hesabını kalıcı olarak silmek istiyorsan aşağıdaki butonu kullanabilirsin. Bu işlem geri alınamaz; hesabın, kullanıcı adın ve tüm verilen sistemden tamamen kaldırılır.",
          button: "Hesabı Kalıcı Olarak Sil", deleting: "Siliniyor...",
          confirm: "Bu işlem geri alınamaz.\n\nHesabın, kullanıcı adın ve tüm verilen kalıcı olarak silinecek.\n\nEmin misin?",
          requiresLogin: "Güvenlik nedeniyle tekrar giriş yapıp bu işlemi deneyin.",
          reauthCancelled: "Doğrulama iptal edildi. Hesap silinmedi.",
          wrongAccount: "Yanlış Google hesabı seçildi. Lütfen silinecek hesabını seçin.",
          error: "Hesap silinemedi. Lütfen tekrar dene.",
        },
      },
      profile: { title: "Profil", playlists: "Derlemeler", games: "Oyun Projeleri", notFound: "Bu gezgin bulunamadı", noBio: "Henüz bir şey yazmamış...", joined: "Katılım" },
      notFound: { subtitle: "Bu patika kaybolmuş", backHome: "← Merkeze Dön" },
      unauthorized: { title: "Erişim Yetkiniz Yok", body: "Bu alana erişmek için gerekli yetkilendirmeye sahip değilsiniz.", backHome: "Ana Sayfaya Dön" },
      header:  { openMenu: "Menüyü Aç", login: "HESAP GİRİŞ" },
      sidebar: {
        modules: "Modüller", account: "Hesabım", support: "Destek",
        adminPanel: "Admin Paneli", adminSub: "Yönetim & Denetim",
        settingsSub: "Profil & Güvenlik", comingSoon: "Yakında · Coming Soon",
        backHome: "← Ana Sayfa", copyright: "© BoneCast Arşivleri\nTüm Hakları Saklıdır",
        modPanel: "Moderatör Paneli", modSub: "Yönetim & Denetim",
        donate: "Destek Ol", donateSub: "BoneCast'i Destekle",
        beat: {
          feed: "Beat Arşivi", feedSub: "Tüm Derlemeler",
          mine: "Beat'lerim",  mineSub: "Kişisel Koleksiyon",
          new:  "Yeni Beat",   newSub:  "Arşive Ekle",
          openMenu: "Menüyü Aç",
        },
        forge: {
          feed: "Forge Arşivi", feedSub: "Tüm Projeler",
          mine: "Koleksiyonum", mineSub: "Kendi Projelerim",
          new:  "Proje Ekle",   newSub:  "Yeni Derleme",
          openMenu: "Forge menüsünü aç",
        },
        frame: {
          feed: "Sinema Arşivi", feedSub: "Tüm Filmler",
          mine: "Koleksiyonum",  mineSub: "Kendi Paylaşımlarım",
          new:  "Film Ekle",     newSub:  "Yeni Paylaşım",
          openMenu: "Frame menüsünü aç",
        },
      },
      hero: {
        tagline: "Est. 2026 · Beta",
        quote: '"Keşfedilmeyi bekleyen bir ses arşivi. Müziği; derle, konuş, oyna."',
        quoteAuthor: "— BoneCast Manifestosu", scrollHint: "Aşağı",
        cta: { enter: "Arşive Gir", community: "Topluluğa Katıl" },
        stats: { playlists: "Müzik Listesi", modules: "Aktif Modül", phase: "Aşama" },
      },
      home: {
        modules: {
          eyebrow: "Platform", title: "Modüller", enter: "Gir", loginRequired: "Giriş Gerekli",
          beat:  { title: "BoneBeat",  subtitle: "Müzik Arşivi",      desc: "Müziğini bir koleksiyoncu titizliğiyle derle. Her liste, tozlu bir rafta bekleyen nadir bir kayıt gibi." },
          frame: { title: "BoneFrame", subtitle: "Cinema Library",    desc: "Gördüğün filmleri bir sinema galerisine dönüştür. Paylaş, keşfet, izleme listeni oluştur." },
          forge: { title: "BoneForge", subtitle: "The Forge · Smithy", desc: "Oyununu, kodunu, scriptini topluluğa sun. Teknik bir ocaktan çıkan her proje burada belgelenir." },
        },
        quickAccess: { eyebrow: "Hızlı Erişim", title: "Arşive Gir", enter: "Erişim", locked: "Giriş Gerekli" },
        admin: { title: "Admin Paneli", sub: "Yönetim & Kullanıcı Denetimi" },
        features: {
          platforms: "Desteklenen Platform",
          languages: "Aktif Dil",
          modules:   "Modül",
          ads:       "Reklam Yok",
          lists:     "Sınırsız Liste",
        },
        langs: {
          eyebrow:    "Çok Dilli Destek",
          title:      "Dilini Seç",
          native:     "Tam Destek",
          active:     "Aktif",
          comingSoon: "Yakında",
          more:       "Daha Fazlası",
        },
        roadmap: {
          eyebrow:    "Yol Haritası",
          title:      "Nereye Gidiyoruz?",
          inProgress: "Geliştiriliyor",
          live:       "Yayında",
          bonebeat:  { name: "BoneBeat",    desc: "Müzik arşivi ve playlist derleme modülü." },
          boneframe: { name: "BoneFrame",   desc: "Sinema galerisi ve film takip modülü." },
          boneforge: { name: "BoneForge",   desc: "Proje ve script paylaşım modülü." },
          bonechat:  { name: "BoneChat",    desc: "Topluluk sohbet ve mesajlaşma modülü — aktif geliştirme." },
          bonebook:  { name: "BoneBook",    desc: "Kitap koleksiyonu ve okuma listesi modülü." },
          more:      { name: "Daha Fazlası", desc: "BoneCast ekosistemi büyümeye devam ediyor..." },
        },
        manifesto: {
          eyebrow: "Vizyon",
          line1: "Müzik,", line2: "bir dil.", line3: "BoneCast,", line4: "onun arşivi.",
          body: "Sadece müzik dinlemiyorsun — onu yaşıyorsun. BoneCast, sesi merkezine alan modüler bir platform olarak insanları birbirine bağlar; ormanın içindeki o eski kütüphane gibi, her rafında bir sır saklar.",
        },
      },
      donate: {
        eyebrow: "Vizyon & Destek",
        title: "Dijital Bellek ve Bağımsız Atölye",
        subtitle: "Algoritmik dayatmaların, veri madenciliğinin ve gürültünün ötesinde; keşfetmek, dinlemek ve üretmek için kurulan bağımsız bir ekosistem.",
        manifesto: "Reklamsız, takip mekanizmasız ve tamamen açık fikirli bir dijital alan.",
        stats: {
          s1: { label: "Modül Sınırı", desc: "Fikir geldikçe yeni bir oda açılır. Tavan yok, takvim baskısı yok." },
          s2: { label: "Aktif Modül", desc: "BoneBeat müzik arşivini, BoneFrame sinema kütüphanesini, BoneForge ise atölyeyi taşır. Üç oda, tek ruh." },
          s3: { label: "Bağımsız Ekosistem", desc: "Tek vizyon, tek çatı. Kimseye değil, yalnızca kullanıcıya hesap verir." },
          s4: { label: "Reklam", desc: "Dikkatiniz satılık değil. Sayfa sizin, sessizlik de." },
        },
        principles: {
          p1: { title: "Kalıcı ve Yaşayan Arşiv", body: "Geçici trendlerin akışında kaybolmayan; müzikten sinemaya derinlikli ve özenle işlenmiş kültürel kayıtlar." },
          p2: { title: "Kendi Kurallarımız, Kendi Altyapımız", body: "Ticari baskılara ve yatırımcı beklentilerine göre değil; yalnızca topluluğun ve projenin vizyonuna göre şekillenen modüller." },
          p3: { title: "Dikkate Saygı (Sıfır Manipülasyon)", body: "Tıklama tuzakları, can sıkıcı pop-up'lar veya dikkat hırsızlığı yok. Ne zaman isterseniz, tam odakla buradayız." },
        },
        quote: "Hızlı tüketilen değil, her ziyaret edildiğinde yeni bir katmanı keşfedilen sağlam bir dijital zemin.",
        support: {
          eyebrow: "Katkı & Dayanışma",
          title: "Projeye Katkıda Bulun",
          intro: "BoneCast'i reklamla değil, onu sevenlerle ayakta tutuyoruz. Katkınız doğrudan şunlara güç verir:",
          pillar1: { title: "Bağımsız Sunucu", body: "Kesintisiz veri tabanı, hızlı yanıt veren altyapı ve güvenli barındırma." },
          pillar2: { title: "Yeni Modüller", body: "BoneBeat, BoneFrame ve BoneForge için yeni araçlar, kütüphaneler ve özellikler." },
          pillar3: { title: "Temiz Kalma Sözü", body: "Reklam almadan, sayfayı ve arayüzü daima sade ve temiz tutma gücü." },
          button: "Destekçi Ol",
          secure: "Shopier güvenli altyapısı ile",
        },
        homeStrip: {
          eyebrow: "BAĞIMSIZ VİZYON",
          title: "Bu Arşivi Birlikte Büyütelim",
          body: "BoneCast'i reklamsız, bağımsız ve topluluk odaklı tutmak için bir kahve ısmarlayarak geliştiriciye destek olabilirsiniz.",
          btn: "Destek Ol",
        },
      },
      bonebeat: {
        archive:          "Arşiv",
        archiveTitle:     "BoneBeat Arşivi",
        myCollection:     "Koleksiyonum",
        myPlaylists:      "Playlistlerim",
        compilations:     "derleme",
        loadingArchive:   "Arşiv yükleniyor...",
        loadingHint:      "İlk kez açılıyorsa birkaç saniye sürebilir.",
        noPlaylists:      "Henüz derlemen yok.",
        noPlaylistsHint:  "Favori şarkılarını, albümlerini veya keşfettiğin müzikleri bir araya getir ve topluluğa sun.",
        createFirst:      "İlk Derlemeni Oluştur",
        archiveEmpty:     "Arşiv henüz boş.",
        archiveEmptyHint: "İlk derlemeni oluştur ve topluluğa katıl.",
        createCompilation:"Derleme Oluştur",
        backToFeed:       "Genel Akışa Dön",
        anonymousUser:    "Anonim Gezgin",
        compilationsLabel:"Derlemeler",
        listCount:        "liste",
        noCompilations:   "Henüz derleme yok.",
        noCompilationsHint:"Bu kullanıcı henüz bir playlist paylaşmamış.",
        confirm: {
          sure:        "Emin misin?",
          deleteBody:  "listesi kalıcı olarak silinecek.",
          blockTitle:  "Kullanıcıyı Engelle",
          blockBody:   "adlı kullanıcı engellendi olarak işaretlenecek.",
        },
        toast: {
          deleted:     "Playlist silindi.",
          deleteFailed:"Silme başarısız.",
          blocked:     "engellendi.",
          blockFailed: "Engelleme başarısız.",
        },
        mod: {
          title:           "Moderatör Paneli",
          totalPlaylists:  "Toplam Playlist",
          uniqueUsers:     "Benzersiz Kullanıcı",
          totalSongs:      "Toplam Şarkı",
          searchPlaceholder:"Playlist adı, kullanıcı adı veya UID ara...",
          colPlaylist:     "Playlist",
          colBy:           "Derleyen",
          colSongs:        "Şarkı",
          colAction:       "Aksiyon",
          noResults:       "Sonuç bulunamadı.",
          blockUser:       "Kullanıcıyı engelle",
        },
        form: {
          eyebrow:           "Yeni Derleme",
          title:             "Playlist Oluştur",
          subtitle:          "Dilediğin şarkıları, albümleri veya podcastleri ekleyebilirsin.",
          nameLabel:         "Liste Adı",
          namePlaceholder:   "Koleksiyonuna bir isim ver...",
          nameRequired:      "Liste adı zorunludur.",
          songRequired:      "En az bir şarkı ekleyin.",
          urlRequired:       "URL zorunludur.",
          unsupported:       "Bu platform henüz desteklenmiyor.",
          unsupportedHint:   "Bu platform henüz desteklenmiyor",
          detected:          "algılandı",
          added:             "Eklenen",
          tracks:            "parça",
          addSong:           "Şarkı / Link Ekle",
          songNamePlaceholder:"Şarkı / Albüm adı (isteğe bağlı)",
          add:               "Ekle",
          supportedPlatforms:"Desteklenen Platformlar",
          moveUp:            "Yukarı",
          moveDown:          "Aşağı",
          remove:            "Kaldır",
          creating:          "Oluşturuluyor...",
          publish:           "Derlemeleri Yayınla",
          created:           "✓ Derleme oluşturuldu!",
          error:             "Hata oluştu.",
        },
      },
      boneframe: {
        archiveEyebrow:   "◈ Film Arşivi ◈",
        archiveTitle:     "BoneFrame Arşivi",
        myEyebrow:        "◈ Koleksiyonum ◈",
        myTitle:          "Framelerim",
        loadingArchive:   "Arşiv yükleniyor...",
        loadingHint:      "Film ve dizi derlemeleri getiriliyor",
        noFrames:         "Henüz bir frame'in yok.",
        noFramesHint:     "Beğendiğin bir film veya diziyi arşive ekle, topluluğa tavsiye et.",
        addFrame:         "Frame Ekle",
        archiveEmpty:     "Arşiv henüz boş.",
        archiveEmptyHint: "İlk içeriği ekle, arşivi başlat.",
        framedBy:         "Framed by",
        errorTitle:       "Bağlantı Hatası",
        reload:           "Sayfayı Yenile",
        types: {
          film:      "Film",
          dizi:      "Dizi",
          belgesel:  "Belgesel",
          animasyon: "Animasyon",
          diger:     "Diğer",
        },
        toast: {
          deleted:     "İçerik silindi.",
          deleteFailed:"Silme başarısız.",
        },
        mod: {
          totalFrames:      "Toplam Frame",
          platformCount:    "Platform Çeşidi",
          colTitle:         "Başlık",
          colPlatform:      "Platform",
          searchPlaceholder:"Başlık, kullanıcı adı veya UID ara...",
        },
        form: {
          eyebrow:          "Yeni Derleme",
          title:            "Frame Ekle",
          subtitle:         "İzlediğin ya da tavsiye etmek istediğin bir içeriğin linkini paylaş.",
          typeLabel:        "İçerik Türü",
          titleLabel:       "Başlık",
          titlePlaceholder: "Örn: Interstellar, Breaking Bad, Cosmos...",
          titleRequired:    "Başlık zorunludur.",
          urlLabel:         "Platform Linki",
          urlPlaceholder:   "https://www.netflix.com/title/...",
          unknownPlatform:  "Tanınmayan platform — link yine de kaydedilir.",
          detected:         "tespit edildi",
          noteLabel:        "Kısa Not (isteğe bağlı)",
          notePlaceholder:  "Neden tavsiye ediyorsun? Nasıl hissettirdi?",
          chars:            "karakter",
          supportedPlatforms:"Desteklenen Platformlar",
          saving:           "Kaydediliyor...",
          submit:           "Frame Ekle",
          noSession:        "Oturum bilgisi bulunamadı. Lütfen tekrar giriş yapın.",
          permissionError:  "İzin hatası: Firebase kuralları bu işlemi reddetti.",
          networkError:     "Ağ hatası: İnternet bağlantınızı kontrol edin.",
          error:            "Paylaşım başarısız.",
        },
      },
      boneforge: {
        archiveEyebrow:   "Teknik Arşiv",
        archiveTitle:     "BoneForge Arşivi",
        myEyebrow:        "Koleksiyonum",
        myTitle:          "Projelerim",
        loadingArchive:   "Arşiv yükleniyor...",
        loadingHint:      "Proje ve oyun derlemeleri getiriliyor",
        noProjects:       "Henüz bir projen yok.",
        noProjectsHint:   "Oyununu, kodunu veya scriptini topluluğa sun. İlk projeyi dövüş!",
        addProject:       "Proje Ekle",
        archiveEmpty:     "Arşiv henüz boş.",
        archiveEmptyHint: "İlk projeyi ekle, arşivi başlat.",
        forgedBy:         "Forged by",
        traveler:         "Gezgin",
        unnamed:          "İsimsiz Proje",
        projects:         "proje",
        words:            "kelime",
        blockUser:        "Kullanıcıyı engelle",
        types: {
          game:   "Oyun",
          code:   "Kod",
          script: "Script",
          other:  "Diğer",
        },
        toast: {
          deleted:     "Proje silindi.",
          deleteFailed:"Silme başarısız.",
        },
        mod: {
          title:            "Moderatör Paneli",
          totalProjects:    "Toplam Proje",
          platformCount:    "Platform Çeşidi",
          colName:          "Proje Adı",
          searchPlaceholder:"Proje adı, kullanıcı adı veya UID ara...",
        },
        form: {
          eyebrow:           "Yeni Derleme",
          title:             "Projeyi Dövüş",
          subtitle:          "Oyununu, kodunu veya scriptini topluluğa sun.",
          typeLabel:         "Proje Türü",
          nameLabel:         "Proje Adı",
          namePlaceholder:   "Örn: Dungeon Crawler Pro",
          urlLabel:          "Proje Linki (isteğe bağlı)",
          urlPlaceholder:    "https://github.com/kullanici/proje",
          unknownPlatform:   "Tanınmayan platform — link yine de kaydedilir.",
          detected:          "tespit edildi",
          descLabel:         "Açıklama * — min {{min}}, max {{max}} kelime",
          descPlaceholder:   "Bu proje ne yapar? Hangi teknolojileri kullanıyor? Neden özel?",
          wordRange:         "Gezgin, açıklaman {{min}} ila {{max}} kelime arasında olmalı. ({{count}} kelime)",
          supportedPlatforms:"Desteklenen Platformlar",
          forgeIt:           "Forge It",
          forging:           "Dövülüyor...",
          waitForDesc:       "Açıklamanı yazana kadar Forge It beklemede kalır.",
          noSession:         "Oturum bilgisi bulunamadı. Lütfen tekrar giriş yapın.",
          permissionError:   "İzin hatası: Firebase kuralları bu işlemi reddetti.",
          networkError:      "Ağ hatası: İnternet bağlantınızı kontrol edin.",
          error:             "Paylaşım başarısız.",
        },
      },
      admin: {
        title:      "Gezgin Yönetimi",
        backToHome: "Ana Menüye Dön",
        you:        "sen",
        user:       "Kullanıcı",
        active:     "Aktif",
        blocked:    "Engelli",
        makeAdmin:  "Admin Yap",
        removeAdmin:"Yetkiyi Al",
        block:      "Engelle",
        unblock:    "Engeli Kaldır",
        rootAdmin:  "Ana Yetkili",
        noUsers:    "Henüz kayıtlı kullanıcı yok.",
        accessDenied:      "Erişim Reddedildi",
        accessDeniedTitle: "Firebase Kuralları Okumayı Engelliyor",
        noReadAccess: "yoluna okuma izni yok.",
        addRule:     "bölümüne gidip şu kuralı ekle",
        errorCode:   "Hata kodu",
        col: { user: "Kullanıcı", email: "E-Posta", role: "Rol", status: "Durum" },
        stats: { total: "Toplam Gezgin", admins: "Admin", blocked: "Engelli" },
        confirm: {
          block:       "Bu kullanıcıyı engellemek istediğine emin misin?\n\nEngellenen kullanıcı sisteme giriş yapamaz.",
          unblock:     "Bu kullanıcının engelini kaldırmak istediğine emin misin?",
          makeAdmin:   "Bu kullanıcıya admin yetkisi vermek istediğine emin misin?\n\nAdmin tüm içerikleri yönetebilir ve kullanıcıları engelleyebilir.",
          removeAdmin: "Bu kullanıcının admin yetkisini almak istediğine emin misin?",
        },
        toast: {
          blocked:  "Kullanıcı engellendi.",
          unblocked:"Engel kaldırıldı.",
          promoted: "Admin yetkisi verildi.",
          demoted:  "Admin yetkisi alındı.",
          error:    "İşlem başarısız",
        },
      },
      legal: {
        backHome: "← Ana Sayfaya Dön", eyebrow: "Yasal Metin",
        lastUpdated: "Son güncelleme: Ocak 2026",
        termsLink: "Kullanım Koşulları", privacyLink: "Gizlilik Politikası",
        copyright: "© BoneCast Arşivleri · Tüm Hakları Saklıdır",
        terms: {
          title: "Kullanım Koşulları",
          s1: { title: "1. Kabul", body: "BoneCast platformuna erişerek veya kullanarak bu Kullanım Koşullarını kabul etmiş olursunuz. Bu koşulları kabul etmiyorsanız lütfen platformu kullanmayınız." },
          s2: { title: "2. Hesap Sorumluluğu", body: "Hesabınızın güvenliğinden ve gerçekleştirilen tüm işlemlerden siz sorumlusunuz. Hesabınıza yetkisiz bir erişim fark ettiğinizde derhal bize bildirmeniz gerekmektedir. Sahte, yanıltıcı veya başkasına ait bilgilerle hesap oluşturmak yasaktır." },
          s3: {
            title: "3. İçerik Kuralları",
            intro: "Platforma yüklenen veya paylaşılan içerikler şu koşullara tabi tutulur:",
            r1: "Hakaret, şiddet ve nefret söylemi içeren içerikler yasaktır.",
            r2: "Telif hakkı ihlali teşkil eden içerikler paylaşılamaz.",
            r3: "Spam, yanıltıcı bağlantı ve zararlı yazılım dağıtımı yasaktır.",
            r4: "Müzik Derleme ve Oyun modüllerine yalnızca platformca izin verilen kaynaklardan bağlantı eklenebilir.",
          },
          s4: { title: "4. Moderasyon ve Hesap Askıya Alma", body: "BoneCast yönetimi, bu koşulları ihlal eden hesapları önceden bildirmeksizin askıya alma veya kalıcı olarak kapatma hakkını saklı tutar. İtirazlarınızı sosyal medya kanallarımız üzerinden iletebilirsiniz." },
          s5: { title: "5. Fikri Mülkiyet", body: "BoneCast logosu, tasarımı ve içerikleri BoneCast Arşivleri'ne aittir. İzinsiz çoğaltılması ve dağıtılması yasaktır. Kullanıcılar, paylaştıkları içeriklerin telif haklarına sahip olduklarını beyan eder." },
          s6: { title: "6. Sorumluluk Sınırlaması", body: "BoneCast, kullanıcıların paylaştığı içeriklerden doğabilecek zararlardan sorumlu tutulamaz. Platform, kesintisiz ve hatasız hizmet garantisi vermez." },
          s7: { title: "7. Değişiklikler", body: "Bu koşullar zaman zaman güncellenebilir. Güncellemeler platforma duyurulacak olup kullanımın sürdürülmesi yeni koşulların kabulü anlamına gelir." },
        },
        privacy: {
          title: "Gizlilik Politikası",
          s1: {
            title: "1. Toplanan Veriler",
            intro: "BoneCast, aşağıdaki verileri toplar ve işler:",
            d1label: "Hesap Bilgileri:", d1: "E-posta adresi, görünen ad ve profil fotoğrafı (isteğe bağlı).",
            d2label: "İçerik Verileri:", d2: "Paylaştığınız müzik derlemeleri ve oyun projeleri.",
            d3label: "Kullanım Verileri:", d3: "Platforma giriş zamanları ve etkileşimler.",
          },
          s2: { title: "2. Firebase ve Veri Depolama", body: "Tüm veriler, Google Firebase altyapısı üzerinden Europe-West1 (Belçika) bölgesindeki sunucularda güvenli biçimde depolanır. Firebase Authentication ve Realtime Database kullanılmaktadır. Google'ın gizlilik politikası geçerlidir." },
          s3: {
            title: "3. Verilerinizin Kullanımı",
            intro: "Toplanan veriler yalnızca şu amaçlarla kullanılır:",
            r1: "Hesabınızı doğrulamak ve yönetmek.",
            r2: "Paylaşımlarınızı diğer kullanıcılara göstermek.",
            r3: "Platform güvenliğini ve moderasyonu sağlamak.",
            noSell: "Verileriniz hiçbir koşulda üçüncü taraflara satılmaz veya reklam amaçlı kullanılmaz.",
          },
          s4: { title: "4. Çerezler (Cookies)", body: "BoneCast, oturum yönetimi için Firebase Authentication'ın yerel depolama mekanizmalarını kullanır. Reklam veya izleme amacıyla çerez kullanılmamaktadır." },
          s5: { title: "5. Verilerinize Erişim ve Silme", body: "Hesabınızdaki verileri Hesap Ayarları sayfasından görüntüleyebilir ve güncelleyebilirsiniz. Hesabınızın tamamen silinmesini talep etmek için sosyal medya kanallarımız üzerinden bizimle iletişime geçebilirsiniz. Silinme talebinin ardından verileriniz 30 gün içinde sistemden kalıcı olarak kaldırılır." },
          s6: { title: "6. Güvenlik", body: "Verilerinizin korunması için Firebase'in sağladığı endüstri standardı şifreleme ve güvenlik kuralları uygulanmaktadır. Bununla birlikte, hiçbir internet iletimi %100 güvenli değildir." },
          s7: { title: "7. İletişim", body: "Gizlilik politikamız hakkında sorularınız için Instagram veya X (Twitter) kanallarımız üzerinden bize ulaşabilirsiniz: @BoneCastOfficial" },
        },
      },
      footer: {
        contact:   "Bize Ulaşın",
        quickAccess: "Hızlı Erişim",
        legal:     "Hukuki",
        copyright: "© 2026 BoneCast Arşivleri · Tüm Hakları Saklıdır",
        email:     "bonecastofficial@gmail.com",
        instagram: "@BoneCastOfficial",
        twitter:   "@BoneCastOfcl",
        youtube:   "@BoneCastOfficial",
        discord:   "@BoneCastOfficial",
        bonechat:  "BoneChat",
        bonebeat:  "BoneBeat",
        boneforge: "BoneForge",
      },
    },
  },

  // ── İNGİLİZCE ────────────────────────────────────────────────────────────
  en: {
    translation: {
      common: {
        loading: "Loading...", save: "Save", cancel: "Cancel",
        delete: "Delete", back: "Go Back", edit: "Edit", confirm: "Confirm",
        checking: "Checking...", sending: "Sending...",
        deleting: "Deleting...", sealing: "Saving...", or: "or",
      },
      comments: {
        title: "Comments", show: "Show comments", hide: "Hide comments",
        count: "{{count}} comments", empty: "No comments yet.",
        label: "Add a comment", placeholder: "Write your comment...", post: "Post",
        posting: "Posting...", delete: "Delete", you: "You", member: "Member",
        loginRequired: "Sign in to comment.", invalid: "Comments must be 1-1000 characters.",
        loadError: "Could not load comments.", saveError: "Could not post comment.", deleteError: "Could not delete comment.",
      },
      auth: {
        login: "Log In", register: "Sign Up", logout: "Log Out",
        email: "Email", password: "Password", passwordRepeat: "Repeat Password",
        displayName: "Full Name", forgotPassword: "Forgot password",
        resetPassword: "Reset Password", resetSend: "Send Reset Email",
        verifyEmail: "Verification email sent.",
        welcomeBack: "Welcome Back", createAccount: "Create Account",
        alreadyHave: "Already have an account?", noAccount: "Don't have an account?",
        backToLogin: "← Back to login",
        backToHome: "← Home",
        archiveEyebrow: "✦ BoneCast Archives ✦",
        loginWith: "Log In", registerWith: "Sign Up",
        googlePrefix: "🔍 Continue with Google",
        googleHint: "First time signing in with Google? Your account will be created automatically.",
        termsAgree: "I have read and agree to the",
        termsLink: "Terms of Service", privacyLink: "Privacy Policy", termsAnd: "and",
        passwordMatch: "✓ Passwords match", passwordNoMatch: "✗ Passwords do not match",
        errors: {
          termsRequired:      "Please accept the terms to continue.",
          nameRequired:       "Name is required.",
          emailRequired:      "Email is required.",
          passwordRequired:   "Password is required.",
          passwordTooShort:   "Password must be at least 6 characters.",
          passwordMismatch:   "Passwords do not match.",
          emailAndPwRequired: "Email and password are required.",
          emailRequired2:     "Enter your email address.",
          nameTaken:          "This name is already taken by another user.",
          generic:            "Something went wrong, please try again.",
          timeout:            "Request timed out. Please try again.",
          userNotFound:       "Incorrect email or password.",
          wrongPassword:      "Incorrect email or password.",
          invalidCredential:  "Incorrect email or password.",
          emailInUse:         "This email address is already in use.",
          invalidEmail:       "Invalid email address.",
          weakPassword:       "Password must be at least 6 characters.",
          tooManyRequests:    "Too many attempts. Please wait a few minutes.",
          networkFailed:      "Connection error. Check your internet connection.",
          popupClosed:        "Google sign-in was cancelled.",
          emailNotVerified:   "Your email has not been verified. Please check your inbox.",
          requiresRecentLogin:"For security, please log in again and retry.",
          dbWriteFailed:      "Database write failed. Check Firebase rules.",
          invalidEmailDomain: "This email service is not supported. Please use a common provider like Gmail, Outlook, or Yahoo.",
          emailRequired3:     "Please enter your email address.",
          termsShort:         "Please accept the terms to continue.",
          resetSent:          "Password reset email sent. Check your inbox.",
        },
        googleProfile: {
          eyebrow:     "Create Profile",
          desc:        "You signed in with Google. Before joining the community, choose a unique username.",
          nameLabel:   "Username",
          namePlaceholder: "A name that represents you...",
          checking:    "Checking...",
          available:   "This name is available!",
          btn:         "Continue",
          hint:        "This name will appear on your profile and community contributions.",
          verified:    "Verified",
        },
        link: {
          eyebrow:           "Account Linking",
          desc:              "An account with this email address already exists. Enter your password to link Google sign-in to your existing account.",
          passwordLabel:     "Existing Account Password",
          passwordPlaceholder: "Enter your password...",
          btn:               "Link Google to My Account",
        },
      },
      settings: {
        title: "Account Settings", eyebrow: "✦ Profile ✦",
        section: {
          profile: "Profile", accountInfo: "Account Information",
          updateName: "Update Username", changePassword: "Change Password",
          dangerZone: "Danger Zone",
        },
        avatar: {
          change: "Change Photo", modalEyebrow: "✦ Select ✦",
          modalTitle: "Profile Photo",
          updated: "Profile photo updated.", failed: "Failed to save photo.",
        },
        bio: {
          label: "About Me (max. 200 characters)",
          placeholder: "Introduce yourself briefly...",
          tooLong: "About Me can be at most 200 characters.",
        },
        nationality: { label: "Nationality", placeholder: "— Select —" },
        language:    { label: "Language Preference" },
        seal: {
          button: "⚜ Save Settings", loading: "Saving...",
          success: "Settings saved. Profile updated.",
          error: "Update failed. Please try again.",
        },
        email: { label: "Email Address (cannot be changed)" },
        name: {
          label: "New Username", placeholder: "Full Name",
          save: "Save", checking: "Checking...",
          success: "Username updated successfully.",
          toastSuccess: "Username updated.",
          empty: "Name cannot be empty.",
          same: "New name must differ from the current name.",
          taken: "This name is already taken by another user.",
          error: "Update failed. Please try again.",
        },
        password: {
          info: "For security, you cannot change your password directly here. Click the button below to send a reset link to",
          infoSuffix: "",
          send: "Send Reset Email", sending: "Sending...",
          success: "Reset link sent to",
          error: "Failed to send email. Please try again.",
        },
        deleteAccount: {
          title: "Permanently Delete Account",
          info: "If you want to permanently delete your account, use the button below. This action cannot be undone; your account, username and all data will be removed.",
          button: "Permanently Delete Account", deleting: "Deleting...",
          confirm: "This action cannot be undone.\n\nYour account, username and all data will be permanently deleted.\n\nAre you sure?",
          requiresLogin: "For security, please log in again and retry.",
          reauthCancelled: "Verification cancelled. Account was not deleted.",
          wrongAccount: "Wrong Google account selected. Please select the account you want to delete.",
          error: "Failed to delete account. Please try again.",
        },
      },
      profile: { title: "Profile", playlists: "Compilations", games: "Game Projects", notFound: "This explorer could not be found", noBio: "Nothing written yet...", joined: "Joined" },
      notFound: { subtitle: "This path is lost", backHome: "← Return to Hub" },
      unauthorized: { title: "Access Denied", body: "You do not have the required permissions to access this area.", backHome: "Back to Home" },
      header:  { openMenu: "Open Menu", login: "SIGN IN" },
      sidebar: {
        modules: "Modules", account: "My Account", support: "Support",
        adminPanel: "Admin Panel", adminSub: "Management & Control",
        settingsSub: "Profile & Security", comingSoon: "Coming Soon",
        backHome: "← Home", copyright: "© BoneCast Archives\nAll Rights Reserved",
        modPanel: "Moderator Panel", modSub: "Management & Control",
        donate: "Support Us", donateSub: "Support BoneCast",
        beat: {
          feed: "Beat Archive",   feedSub: "All Compilations",
          mine: "My Beats",       mineSub: "Personal Collection",
          new:  "New Beat",       newSub:  "Add to Archive",
          openMenu: "Open Menu",
        },
        forge: {
          feed: "Forge Archive",  feedSub: "All Projects",
          mine: "My Collection",  mineSub: "My Projects",
          new:  "Add Project",    newSub:  "New Compilation",
          openMenu: "Open Forge menu",
        },
        frame: {
          feed: "Cinema Archive", feedSub: "All Films",
          mine: "My Collection",  mineSub: "My Shared Films",
          new:  "Add Film",       newSub:  "New Entry",
          openMenu: "Open Frame menu",
        },
      },
      hero: {
        tagline: "Est. 2026 · Beta",
        quote: '"An archive of sounds waiting to be discovered. Compile, talk, play."',
        quoteAuthor: "— BoneCast Manifesto", scrollHint: "Scroll",
        cta: { enter: "Enter Archive", community: "Join Community" },
        stats: { playlists: "Music Lists", modules: "Active Modules", phase: "Phase" },
      },
      home: {
        modules: {
          eyebrow: "Platform", title: "Modules", enter: "Enter", loginRequired: "Login Required",
          beat:  { title: "BoneBeat",  subtitle: "Music Archive",     desc: "Curate your music with collector's precision. Every list is a rare record waiting on a dusty shelf." },
          frame: { title: "BoneFrame", subtitle: "Cinema Library",    desc: "Turn the films you've seen into a cinema gallery. Share, discover, build your watchlist." },
          forge: { title: "BoneForge", subtitle: "The Forge · Smithy", desc: "Present your game, code or script to the community. Every project forged here is documented." },
        },
        quickAccess: { eyebrow: "Quick Access", title: "Enter Archive", enter: "Access", locked: "Login Required" },
        admin: { title: "Admin Panel", sub: "Management & User Control" },
        features: {
          platforms: "Supported Platforms",
          languages: "Active Languages",
          modules:   "Modules",
          ads:       "No Ads",
          lists:     "Unlimited Lists",
        },
        langs: {
          eyebrow:    "Multilingual Support",
          title:      "Choose Your Language",
          native:     "Full Support",
          active:     "Active",
          comingSoon: "Coming Soon",
          more:       "More",
        },
        roadmap: {
          eyebrow:    "Roadmap",
          title:      "Where Are We Going?",
          inProgress: "In Development",
          live:       "Live",
          bonebeat:  { name: "BoneBeat",    desc: "Music archive and playlist curation module." },
          boneframe: { name: "BoneFrame",   desc: "Cinema gallery and film tracking module." },
          boneforge: { name: "BoneForge",   desc: "Project and script sharing module." },
          bonechat:  { name: "BoneChat",    desc: "Community chat and messaging module — actively in development." },
          bonebook:  { name: "BoneBook",    desc: "Book collection and reading list module." },
          more:      { name: "More",         desc: "The BoneCast ecosystem keeps growing..." },
        },
        manifesto: {
          eyebrow: "Vision",
          line1: "Music,", line2: "a language.", line3: "BoneCast,", line4: "its archive.",
          body: "You're not just listening to music — you're living it. BoneCast connects people as a sound-centred modular platform; like that old library deep in the forest, every shelf holds a secret.",
        },
      },
      donate: {
        eyebrow: "Vision & Support",
        title: "Digital Memory and an Independent Workshop",
        subtitle: "Beyond algorithmic imposition, data mining, and noise: an independent ecosystem built for discovery, listening, and making.",
        manifesto: "An ad-free, tracking-free digital space with an open mind.",
        stats: {
          s1: { label: "Module Limit", desc: "A new room opens whenever an idea arrives. No ceiling, no calendar pressure." },
          s2: { label: "Active Modules", desc: "BoneBeat holds the music archive, BoneFrame the cinema library, and BoneForge the workshop. Three rooms, one spirit." },
          s3: { label: "Independent Ecosystem", desc: "One vision, one roof. Answerable to no one but its users." },
          s4: { label: "Ads", desc: "Your attention is not for sale. The page is yours, and so is the silence." },
        },
        principles: {
          p1: { title: "A Lasting, Living Archive", body: "Cultural records, thoughtfully curated from music to cinema, that don't disappear in the churn of passing trends." },
          p2: { title: "Our Rules, Our Infrastructure", body: "Modules shaped by the community and the project's vision, not by commercial pressure or investor expectations." },
          p3: { title: "Respect for Attention (Zero Manipulation)", body: "No clickbait, intrusive pop-ups, or attention theft. Whenever you choose to visit, we're here with your full focus in mind." },
        },
        quote: "A solid digital foundation, not for quick consumption, but for discovering a new layer with every visit.",
        support: {
          eyebrow: "Support & Solidarity",
          title: "Contribute to the Project",
          intro: "We keep BoneCast alive through the people who love it, not through ads. Your contribution directly powers:",
          pillar1: { title: "Independent Server", body: "A reliable database, responsive infrastructure, and secure hosting." },
          pillar2: { title: "New Modules", body: "New tools, libraries, and features for BoneBeat, BoneFrame, and BoneForge." },
          pillar3: { title: "Keeping the Experience Clean", body: "The ability to keep the page and interface simple and clean, without advertising." },
          button: "Become a Supporter",
          secure: "Powered by Shopier's secure infrastructure",
        },
        homeStrip: {
          eyebrow: "INDEPENDENT VISION",
          title: "Keep This Archive Alive",
          body: "Support the developer with a coffee to keep BoneCast ad-free, independent, and community-driven.",
          btn: "Support Us",
        },
      },
      bonebeat: {
        archive:          "Archive",
        archiveTitle:     "BoneBeat Archive",
        myCollection:     "My Collection",
        myPlaylists:      "My Playlists",
        compilations:     "compilations",
        loadingArchive:   "Loading archive...",
        loadingHint:      "If this is your first visit, it may take a few seconds.",
        noPlaylists:      "No compilations yet.",
        noPlaylistsHint:  "Bring together your favourite tracks, albums or discoveries and share them with the community.",
        createFirst:      "Create Your First Compilation",
        archiveEmpty:     "The archive is empty.",
        archiveEmptyHint: "Create the first compilation and join the community.",
        createCompilation:"Create Compilation",
        backToFeed:       "Back to Feed",
        anonymousUser:    "Anonymous User",
        compilationsLabel:"Compilations",
        listCount:        "lists",
        noCompilations:   "No compilations yet.",
        noCompilationsHint:"This user hasn't shared any playlists yet.",
        confirm: {
          sure:        "Are you sure?",
          deleteBody:  "will be permanently deleted.",
          blockTitle:  "Block User",
          blockBody:   "will be marked as blocked.",
        },
        toast: {
          deleted:     "Playlist deleted.",
          deleteFailed:"Failed to delete.",
          blocked:     "blocked.",
          blockFailed: "Failed to block user.",
        },
        mod: {
          title:           "Moderation Panel",
          totalPlaylists:  "Total Playlists",
          uniqueUsers:     "Unique Users",
          totalSongs:      "Total Songs",
          searchPlaceholder:"Search by playlist name, username or UID...",
          colPlaylist:     "Playlist",
          colBy:           "By",
          colSongs:        "Songs",
          colAction:       "Action",
          noResults:       "No results found.",
          blockUser:       "Block user",
        },
        form: {
          eyebrow:           "New Compilation",
          title:             "Create Playlist",
          subtitle:          "Add any tracks, albums or podcasts you like.",
          nameLabel:         "List Name",
          namePlaceholder:   "Give your collection a name...",
          nameRequired:      "List name is required.",
          songRequired:      "Add at least one track.",
          urlRequired:       "URL is required.",
          unsupported:       "This platform is not yet supported.",
          unsupportedHint:   "This platform is not yet supported",
          detected:          "detected",
          added:             "Added",
          tracks:            "tracks",
          addSong:           "Add Song / Link",
          songNamePlaceholder:"Song / Album name (optional)",
          add:               "Add",
          supportedPlatforms:"Supported Platforms",
          moveUp:            "Move up",
          moveDown:          "Move down",
          remove:            "Remove",
          creating:          "Creating...",
          publish:           "Publish Compilation",
          created:           "✓ Compilation created!",
          error:             "An error occurred.",
        },
      },
      boneframe: {
        archiveEyebrow:   "◈ Cinema Archive ◈",
        archiveTitle:     "BoneFrame Archive",
        myEyebrow:        "◈ My Collection ◈",
        myTitle:          "My Frames",
        loadingArchive:   "Loading archive...",
        loadingHint:      "Fetching film and series entries",
        noFrames:         "You have no frames yet.",
        noFramesHint:     "Add a film or series you enjoyed and share it with the community.",
        addFrame:         "Add Frame",
        archiveEmpty:     "Archive is empty.",
        archiveEmptyHint: "Add the first entry and start the archive.",
        framedBy:         "Framed by",
        errorTitle:       "Connection Error",
        reload:           "Reload Page",
        types: {
          film:      "Film",
          dizi:      "Series",
          belgesel:  "Documentary",
          animasyon: "Animation",
          diger:     "Other",
        },
        toast: {
          deleted:     "Content deleted.",
          deleteFailed:"Delete failed.",
        },
        mod: {
          totalFrames:      "Total Frames",
          platformCount:    "Platform Variety",
          colTitle:         "Title",
          colPlatform:      "Platform",
          searchPlaceholder:"Search by title, username or UID...",
        },
        form: {
          eyebrow:          "New Entry",
          title:            "Add Frame",
          subtitle:         "Share a link to content you watched or want to recommend.",
          typeLabel:        "Content Type",
          titleLabel:       "Title",
          titlePlaceholder: "E.g. Interstellar, Breaking Bad, Cosmos...",
          titleRequired:    "Title is required.",
          urlLabel:         "Platform Link",
          urlPlaceholder:   "https://www.netflix.com/title/...",
          unknownPlatform:  "Unknown platform — link will still be saved.",
          detected:         "detected",
          noteLabel:        "Short Note (optional)",
          notePlaceholder:  "Why do you recommend it? How did it make you feel?",
          chars:            "characters",
          supportedPlatforms:"Supported Platforms",
          saving:           "Saving...",
          submit:           "Add Frame",
          noSession:        "Session not found. Please log in again.",
          permissionError:  "Permission error: Firebase rules rejected this action.",
          networkError:     "Network error: Check your internet connection.",
          error:            "Submission failed.",
        },
      },
      boneforge: {
        archiveEyebrow:   "Technical Archive",
        archiveTitle:     "BoneForge Archive",
        myEyebrow:        "My Collection",
        myTitle:          "My Projects",
        loadingArchive:   "Loading archive...",
        loadingHint:      "Fetching project and game compilations",
        noProjects:       "You have no projects yet.",
        noProjectsHint:   "Share your game, code or script with the community. Forge the first one!",
        addProject:       "Add Project",
        archiveEmpty:     "Archive is empty.",
        archiveEmptyHint: "Add the first project and start the archive.",
        forgedBy:         "Forged by",
        traveler:         "Traveler",
        unnamed:          "Unnamed Project",
        projects:         "projects",
        words:            "words",
        blockUser:        "Block user",
        types: {
          game:   "Game",
          code:   "Code",
          script: "Script",
          other:  "Other",
        },
        toast: {
          deleted:     "Project deleted.",
          deleteFailed:"Delete failed.",
        },
        mod: {
          title:            "Moderation Panel",
          totalProjects:    "Total Projects",
          platformCount:    "Platform Variety",
          colName:          "Project Name",
          searchPlaceholder:"Search by project name, username or UID...",
        },
        form: {
          eyebrow:           "New Compilation",
          title:             "Forge Your Project",
          subtitle:          "Share your game, code or script with the community.",
          typeLabel:         "Project Type",
          nameLabel:         "Project Name",
          namePlaceholder:   "E.g. Dungeon Crawler Pro",
          urlLabel:          "Project Link (optional)",
          urlPlaceholder:    "https://github.com/user/project",
          unknownPlatform:   "Unknown platform — link will still be saved.",
          detected:          "detected",
          descLabel:         "Description * — min {{min}}, max {{max}} words",
          descPlaceholder:   "What does this project do? What tech does it use? Why is it special?",
          wordRange:         "Your description must be between {{min}} and {{max}} words. ({{count}} words)",
          supportedPlatforms:"Supported Platforms",
          forgeIt:           "Forge It",
          forging:           "Forging...",
          waitForDesc:       "Write a description to unlock Forge It.",
          noSession:         "Session not found. Please log in again.",
          permissionError:   "Permission error: Firebase rules rejected this action.",
          networkError:      "Network error: Check your internet connection.",
          error:             "Submission failed.",
        },
      },
      admin: {
        title:      "User Management",
        backToHome: "Back to Home",
        you:        "you",
        user:       "User",
        active:     "Active",
        blocked:    "Blocked",
        makeAdmin:  "Make Admin",
        removeAdmin:"Remove Admin",
        block:      "Block",
        unblock:    "Unblock",
        rootAdmin:  "Root Admin",
        noUsers:    "No registered users yet.",
        accessDenied:      "Access Denied",
        accessDeniedTitle: "Firebase Rules Are Blocking Read Access",
        noReadAccess: "path has no read permission.",
        addRule:     "section and add the following rule",
        errorCode:   "Error code",
        col: { user: "User", email: "Email", role: "Role", status: "Status" },
        stats: { total: "Total Users", admins: "Admins", blocked: "Blocked" },
        confirm: {
          block:       "Are you sure you want to block this user?\n\nBlocked users will not be able to log in.",
          unblock:     "Are you sure you want to unblock this user?",
          makeAdmin:   "Are you sure you want to grant admin access to this user?\n\nAdmins can manage all content and block users.",
          removeAdmin: "Are you sure you want to remove admin access from this user?",
        },
        toast: {
          blocked:  "User has been blocked.",
          unblocked:"Block removed.",
          promoted: "Admin access granted.",
          demoted:  "Admin access removed.",
          error:    "Operation failed",
        },
      },
      legal: {
        backHome: "← Back to Home", eyebrow: "Legal Text",
        lastUpdated: "Last updated: January 2026",
        termsLink: "Terms of Service", privacyLink: "Privacy Policy",
        copyright: "© BoneCast Archives · All Rights Reserved",
        terms: {
          title: "Terms of Service",
          s1: { title: "1. Acceptance", body: "By accessing or using the BoneCast platform, you agree to these Terms of Service. If you do not agree, please do not use the platform." },
          s2: { title: "2. Account Responsibility", body: "You are responsible for the security of your account and all activities performed under it. You must notify us immediately if you detect unauthorised access. Creating accounts with false, misleading, or third-party information is prohibited." },
          s3: {
            title: "3. Content Rules",
            intro: "Content uploaded to or shared on the platform is subject to the following conditions:",
            r1: "Content containing harassment, violence, or hate speech is prohibited.",
            r2: "Content that constitutes copyright infringement may not be shared.",
            r3: "Spam, misleading links, and distribution of malware are prohibited.",
            r4: "Links to the Music and Game modules may only be added from sources permitted by the platform.",
          },
          s4: { title: "4. Moderation & Account Suspension", body: "BoneCast management reserves the right to suspend or permanently close accounts that violate these terms without prior notice. You may submit appeals via our social media channels." },
          s5: { title: "5. Intellectual Property", body: "The BoneCast logo, design, and content belong to BoneCast Archives. Unauthorised reproduction and distribution are prohibited. Users warrant that they hold the copyright to any content they share." },
          s6: { title: "6. Limitation of Liability", body: "BoneCast cannot be held liable for damages arising from content shared by users. The platform does not guarantee uninterrupted or error-free service." },
          s7: { title: "7. Changes", body: "These terms may be updated from time to time. Updates will be announced on the platform and continued use constitutes acceptance of the new terms." },
        },
        privacy: {
          title: "Privacy Policy",
          s1: {
            title: "1. Data Collected",
            intro: "BoneCast collects and processes the following data:",
            d1label: "Account Information:", d1: "Email address, display name, and profile photo (optional).",
            d2label: "Content Data:", d2: "Music compilations and game projects you share.",
            d3label: "Usage Data:", d3: "Platform login times and interactions.",
          },
          s2: { title: "2. Firebase & Data Storage", body: "All data is securely stored on servers in the Europe-West1 (Belgium) region via Google Firebase infrastructure. Firebase Authentication and Realtime Database are used. Google's privacy policy applies." },
          s3: {
            title: "3. Use of Your Data",
            intro: "Collected data is used solely for the following purposes:",
            r1: "To verify and manage your account.",
            r2: "To display your content to other users.",
            r3: "To ensure platform security and moderation.",
            noSell: "Your data will never be sold to third parties or used for advertising under any circumstances.",
          },
          s4: { title: "4. Cookies", body: "BoneCast uses Firebase Authentication's local storage mechanisms for session management. No cookies are used for advertising or tracking purposes." },
          s5: { title: "5. Accessing & Deleting Your Data", body: "You can view and update your account data on the Account Settings page. To request complete deletion of your account, please contact us via our social media channels. Following a deletion request, your data will be permanently removed from our systems within 30 days." },
          s6: { title: "6. Security", body: "Industry-standard encryption and security rules provided by Firebase are applied to protect your data. However, no internet transmission is 100% secure." },
          s7: { title: "7. Contact", body: "For questions about our privacy policy, please reach us via our Instagram or X (Twitter) channels: @BoneCastOfficial" },
        },
      },
      footer: {
        contact:     "Contact Us",
        quickAccess: "Quick Access",
        legal:       "Legal",
        copyright:   "© 2026 BoneCast Archives · All Rights Reserved",
        email:       "bonecastofficial@gmail.com",
        instagram:   "@BoneCastOfficial",
        twitter:     "@BoneCastOfcl",
        youtube:     "@BoneCastOfficial",
        discord:     "@BoneCastOfficial",
        bonechat:    "BoneChat",
        bonebeat:    "BoneBeat",
        boneforge:   "BoneForge",
      },
    },
  },
};

// ── Başlatma ──────────────────────────────────────────────────────────────────
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "bonecast_language",
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
    saveMissing: process.env.NODE_ENV === "development",
  });

export default i18n;
